var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightTriangleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "12px",
    viewBox: "0 0 7 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3340A02F-88A5-43A4-9D6B-AB0877506784") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-97.000000, -1507.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(76.000000, 1506.350000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2249994,3.9131573 L29.545688,8.46125054 C29.9260738,8.86165667 29.9098442,9.49461361 29.509438,9.87499943 C29.3235885,10.0515565 29.077033,10.15 28.8206886,10.15 L20.1793114,10.15 C19.6270267,10.15 19.1793114,9.70228475 19.1793114,9.15 C19.1793114,8.89365556 19.2777549,8.64710012 19.454312,8.46125054 L23.7750006,3.9131573 C24.1553864,3.51275117 24.7883433,3.4965215 25.1887495,3.87690733 C25.2011406,3.88867889 25.2132279,3.90076618 25.2249994,3.9131573 Z",
    id: "Triangle",
    transform: "translate(24.500000, 6.650000) rotate(90.000000) translate(-24.500000, -6.650000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTriangleIcon);
export default __webpack_public_path__ + "static/media/right-triangle-icon.116bbd9bac8e8fbcc2d8690cf18d5eb7.svg";
export { ForwardRef as ReactComponent };